exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".docket-popup .bulk-client-code{width:60%}.docket-popup .bg-color-grey{padding:8px;background:#eee}.docket-popup .footer-btn{margin-top:16px}.docket-popup .docket-info-section{margin:5px}.docket-popup .docket-number-link{cursor:pointer}.docket-popup .email-bulk-buy-container{display:flex;align-items:center}.docket-popup .email-bulk-buy-button{margin-top:18px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/less-loader!./src/components/case/docket/popups/DocketPopup.less
// module id = 1617
// module chunks = 0